import React from 'react';
import {Header,Item, Label,  Breadcrumb, Table, Transition, Icon, Segment, Container, Loader, Dropdown, Divider, Form, Dimmer, Button, Grid,Input, Radio, Popup, List} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';



const InscripcionLista=({ id, ajaxCallInProgress, errors=[],filtro, cambiarEstatus, strings, cursoCombo, onChange,inscripcion, download, pagos, resultadosExamen, onShowAvance})=>{
    
    
	return (
        <Container>
             <Segment>
            <Form>
                     <Form.Field >            
                          <label  >{strings?strings["busqueda"]:""}</label>
                          <Input 
                                placeholder={strings?strings["alumno"]:""} 
                                name="filtro"
                                onChange={onChange}
                                value={filtro}
                                icon='edit'/>
                        </Form.Field>
                    </Form>   
                 </Segment>
          
        {inscripcion.length>0?
       
            
                <Container>
         
         
                 <Segment clearing>
                    <Header floated='left'>
                       Alumnos inscritos: {inscripcion.length}
                    </Header>
                    <Header floated='right'>
                      reporte<Icon color="green" size="small" link onClick={download} name='file excel' />
                    </Header>

                  
        
            </Segment>
                 
         
                    <Table celled>
                        <Table.Header>
                        <Table.Row>
                            
                                <Table.HeaderCell>{strings?strings["alumno"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["mail"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["pais"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["empresa"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["telefono"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">{strings?strings["pagos"]:""}</Table.HeaderCell>
        
                        
                        </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            
                            {inscripcion.map(alumno =>
                            
                            <Table.Row>
                                    <Table.Cell>
                                         {alumno.idEstatus==1?
                                            <Popup
                                                trigger={
                                                    <Icon name='user' link 
                                                    size="large" color="green"
                                                    />
                                                }
                                                content={alumno.estatus}
                                            />
                                        :
                                            ""
                                        }
                                        {alumno.idEstatus==2?
                                            <Popup
                                                trigger={
                                                    <Icon name='add user' link 
                                                    size="large" color="blue"
                                                    />
                                                }
                                                content={alumno.estatus}
                                            />
                                        :
                                            ""
                                        }
                                       
                                        {alumno.idEstatus==8?
                                            <Popup
                                                trigger={
                                                    <Icon name='user' link 
                                                    size="large" color='red'
                                                    />
                                                }
                                                content={alumno.estatus}
                                            />
                                        :
                                            ""
                                        }
        
                                        {alumno.idEstatus==9?
                                            <Popup
                                                trigger={
                                                    <Icon name='user' link 
                                                    size="large" color="yellow"
                                                    />
                                                }
                                                content={alumno.estatus}
                                            />
                                        :
                                            ""
                                        }
                                        
                                            
                                        {alumno.usuario}
                                   </Table.Cell>    
                                    <Table.Cell>
                                        {alumno.mail}
                                    </Table.Cell>    
                                    <Table.Cell >
                                        {alumno.pais}
                                    </Table.Cell>    
                                    <Table.Cell >
                                        {alumno.empresa}
                                    </Table.Cell>    
                                    <Table.Cell textAlign="right">
                                        {alumno.telefono}
                                    </Table.Cell>    
                                  
                                    
                                    
                                    <Table.Cell textAlign="center">
                                        <List horizontal>
                                           
                                            <List.Item>
                                                <Popup
                                                    trigger={
                                                        <Icon name='money bill alternate outline' link 
                                                       
                                                        size="large" color="green"
                                                        onClick={()=>pagos(alumno.id)} />
                                                    }
                                                    content='visualizar pagos'
                                                  />
                                            </List.Item>
                                        </List>
                                    </Table.Cell>
                            
                                 
                                  
                            </Table.Row>    
                            
                            )}
                             
                        </Table.Body>    
                    </Table>
        
        
        
                </Container>
        
                :
        
                "Seleccióne un curso"
        
            }        
        
        
        </Container>
	);
};



export default InscripcionLista;